// extracted by css-extract-rspack-plugin
export default {"counterSkeleton":"OpenCommentsPanelButton-module__counterSkeleton__vOIbC"};